export class SuitabilitySantanderAction {
  public static getQuestionsSantander: string =
    '[Suitability_Santander] get_questions_santander';
  public static getQuestionsSantanderError: string =
    '[Suitability_Santander] get_questions_santander_error';
  public static getQuestionsSantanderSuccess: string =
    '[Suitability_Santander] get_questions_santander_success';

  public static setCustomerAnswers: string =
    '[Suitability_Santander] set_customer_answer';
  public static setCustomerAnswersError: string =
    '[Suitability_Santander] set_customer_answer_error';
  public static setCustomerAnswersSuccess: string =
    '[Suitability_Santander] set_customer_answer_success';

  public static sendCustomerAnswers: string =
    '[Suitability_Santander] send_customer_answer';
  public static sendCustomerAnswersError: string =
    '[Suitability_Santander] send_customer_answer_error';
  public static sendCustomerAnswersSuccess: string =
    '[Suitability_Santander] send_customer_answer_success';

  public static acceptCustomerAnswers: string =
    '[Suitability_Santander] accept_customer_answer';
  public static acceptCustomerAnswersError: string =
    '[Suitability_Santander] accept_customer_answer_error';
  public static acceptCustomerAnswersSuccess: string =
    '[Suitability_Santander] accept_customer_answer_success';

  public static getProfileSantander: string =
    '[Suitability_Santander] get_profile_santander';
  public static getProfileSantanderError: string =
    '[Suitability_Santander] get_profile_santander_error';
  public static getProfileSantanderSuccess: string =
    '[Suitability_Santander] get_profile_santander_success';

  public static checkClientExcludeFromCommunication: string =
    '[Suitability_Santander] check_client_exclude_from_communication';
  public static checkClientExcludeFromCommunicationError: string =
    '[Suitability_Santander] check_client_exclude_from_communication_error';
  public static checkClientExcludeFromCommunicationSuccess: string =
    '[Suitability_Santander] check_client_exclude_from_communication_success';

  public static generateFittingProfileSuitability = '[OQ-SUITABILITY] GENERATE_FITTING_PROFILE_SUITABILITY';
  public static generateFittingProfileSuitabilitySuccess = '[OQ-SUITABILITY] GENERATE_FITTING_PROFILE_SUITABILITY_SUCCESS';
  public static generateFittingProfileSuitabilityError = '[OQ-SUITABILITY] GENERATE_FITTING_PROFILE_SUITABILITY_ERROR';


  public static acceptFittingProfileSuitability = '[OQ-SUITABILITY] ACCEPT_FITTING_PROFILE_SUITABILITY';
  public static acceptFittingProfileSuitabilitySuccess = '[OQ-SUITABILITY] ACCEPT_FITTING_PROFILE_SUITABILITY_SUCCESS';
  public static acceptFittingProfileSuitabilityError = '[OQ-SUITABILITY] ACCEPT_FITTING_PROFILE_SUITABILITY_ERROR';

  public static getUserInvestorTypeSuitability = '[OQ-SUITABILITY] GET_USER_INVESTOR_TYPE_SUITABILITY_PUBLIC';
  public static getUserInvestorTypeSuitabilitySuccess = '[OQ-SUITABILITY] GET_USER_INVESTOR_TYPE_SUITABILITY_PUBLIC_SUCCESS';
  public static getUserInvestorTypeSuitabilityError = '[OQ-SUITABILITY] GET_USER_INVESTOR_TYPE_SUITABILITY_PUBLIC_ERROR';

  constructor(public type: string, public payload?: any) {}
}
